import { render, staticRenderFns } from "./MenuSelect.vue?vue&type=template&id=303a8a2e&"
import script from "./MenuSelect.vue?vue&type=script&lang=js&"
export * from "./MenuSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports